import {BaseView} from '../core/view';
import {ClassUtil} from '../utils/class-util';

const hasOptOutCookie = function () {
    return (document.cookie.match(/^(.*;)?\s*weatherTrackingOptOut\s*=\s*[^;]+(.*)?$/) != null);
};

const adaptButton = function(hasCookie) {
    if(hasCookie) {
        ClassUtil.removeClass(document.querySelector('.js-weather-opt-in-button'), 'hidden');
        ClassUtil.addClass(document.querySelector('.js-weather-opt-out-button'), 'hidden');
    } else {
        ClassUtil.removeClass(document.querySelector('.js-weather-opt-out-button'), 'hidden');
        ClassUtil.addClass(document.querySelector('.js-weather-opt-in-button'), 'hidden');
    }

};

export default BaseView.extend({
    el: '.js-weather-tracking',

    events: {
        'click .js-weather-opt-out-button': 'onClickHandleSetting',
        'click .js-weather-opt-in-button': 'onClickHandleSetting'
    },

    initialize: function () {
        adaptButton(hasOptOutCookie());
    },

    onClickHandleSetting: function (e) {
        const hasCookie = hasOptOutCookie();
        if(hasCookie) {
            document.cookie = "weatherTrackingOptOut=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        } else {
            document.cookie = "weatherTrackingOptOut=1; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/";
        }
        adaptButton(!hasCookie);
    },
});